/**
 * @author Carlos Fernando Herrera Guillen
 * @Copyright (c) Infotrack. All rights reserved.
 */

import ModeloImpresion from 'Infotrack@Modelos/smartStock/impresion';
import ImprimirItemEtiqueta from 'Infotrack@Modelos/smartStock/impresion/entidades/IImprimirItemEtiqueta';
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';

export default class EntidadesFiltroInvenitarioCM {
    private modeloImpresion: ModeloImpresion;

    constructor() {
        this.modeloImpresion = new ModeloImpresion();
    }

    public async ImprimirItems(itemsImpresion: ImprimirItemEtiqueta) {
        const respuesta = await Promise.all([this.modeloImpresion.imprimirEtiquetaMiddleware(itemsImpresion)]);
        return respuesta[0].data;
    }

    public validarEntidadImpresion = (itemsImpresion: ImprimirItemEtiqueta, esPallet: boolean) => {
        if (
            itemsImpresion.IdEtiqueta === 0 ||
            itemsImpresion.NumeroCopias === 0 ||
            itemsImpresion.ItemsMovimiento.length === 0 ||
            (itemsImpresion.IdEtiqueta === 0 && esPallet && itemsImpresion.CantidadPallet === 0)
        ) {
            notificacionGlobal('comunes.alerta.camposIncompletos', 6000, 'warning', true);
            return false;
        }
        if (esPallet && itemsImpresion.CantidadPallet === 0) {
            notificacionGlobal('comunes.alerta.camposIncompletos', 6000, 'warning', true);
            return false;
        }

        return true;
    };
}
